import Vue from "vue";

import ShowPasswordIcon from "./components/UI/ShowPasswordIcon";
import HidePasswordIcon from "./components/UI/HidePasswordIcon";
import ButtonLoader from "./components/UI/ButtonLoader";
import PageHeader from "./components/UI/PageHeader";
import Loader from "./components/UI/Loader";
import Modal from "./components/UI/Modal/index";
import FormSelect from "./components/UI/FormSelect";
import VerticalEllipsis from "./components/UI/VerticalEllipsisSvg";
import SearchIcon from "./components/UI/SearchIconSvg";
import DeleteModal from "@/components/UI/Modal/DeleteModal";
import UpdateStatusModal from "@/components/UI/Modal/UpdateStatusModal";
import ImageUpload from "@/components/UI/ImageUpload/index";
import DocumentUpload from "@/components/UI/DocumentUpload/index";
import Tooltip from "@/components/UI/Tooltip";
import Badge from "@/components/UI/Badge";
import PrimaryButton from "@/components/UI/PrimaryButton";
import Accordion from "@/components/UI/Accordion";
import AccordionItem from "@/components/UI/AccordionItem";

import EmailInput from "@/components/UI/EmailInput";
import RadioInput from "@/components/UI/RadioInput";
import BaseCheckbox from "@/components/UI/BaseCheckbox";
import BulkAction from "@/components/UI/BulkAction";
import BaseButton from "@/components/UI/BaseButton";
import BaseInput from "@/components/UI/BaseInput";
import AutoComplete from "@/components/UI/AutoComplete";
import StarWrapper from "@/components/UI/widget/StarsWrapper";

// svgs
import AcceptIcon from "@/components/UI/svgs/AcceptIcon";
import CancelIcon from "@/components/UI/svgs/CancelIcon";
import CardIcon from "@/components/UI/svgs/CardIcon";
import DeclineIcon from "@/components/UI/svgs/DeclineIcon";
import DetailsIcon from "@/components/UI/svgs/DetailsIcon";
import EditIcon from "@/components/UI/svgs/EditIcon";
import TimelineIcon from "@/components/UI/svgs/TimelineIcon";
import EyeIcon from "@/components/UI/svgs/EyeIcon";
import VehicleIcon from "@/components/UI/svgs/VehicleIcon";
import MessageIcon from "@/components/UI/svgs/MessageIcon";
import PackageAndTagIcon from "@/components/UI/svgs/PackageAndTagIcon";
import LabelIcon from "@/components/UI/svgs/LabelIcon";
import ProcessIcon from "@/components/UI/svgs/ProcessHandOffIcon";
import ReturnIcon from "@/components/UI/svgs/ReturnIcon";
import FulfillmentIcon from "@/components/UI/svgs/FulfillmentIcon";
import AcceptPackageIcon from "@/components/UI/svgs/AcceptPackageIcon";
import TableIcon from "@/components/UI/svgs/TableIcon";
import TrackingIcon from "@/components/UI/svgs/TrackingIcon";
import UpdateIcon from "@/components/UI/svgs/UpdateIcon";
import UploadDocIcon from "@/components/UI/svgs/UploadDocIcon";
import RemoveIcon from "@/components/UI/svgs/RemoveIcon";
import EmptyTableIcon from "@/components/UI/svgs/EmptyTableIcon";
import ActionPopup from "@/components/UI/ActionPopup";
import EmptyState from "@/components/UI/EmptyState";
import EmptyUsersIcon from "@/components/UI/svgs/EmptyUsersIcon";
import EmptyRolesIcon from "@/components/UI/svgs/EmptyRolesIcon";
import EmptyKPIIcon from "@/components/UI/svgs/EmptyKPIIcon";
import EmptyJobLevelIcon from "@/components/UI/svgs/EmptyJobLevelIcon";
import EmptyFunctionIcon from "@/components/UI/svgs/EmptyFunctionIcon";
import EmptyDesignationIcon from "@/components/UI/svgs/EmptyDesignationIcon";
import EmptyIncidentIcon from "@/components/UI/svgs/EmptyIncidentIcon";
import EmptyTransloadIcon from "@/components/UI/svgs/EmptyTransloadIcon";
import EmptyLocationIcon from "@/components/UI/svgs/EmptyLocationIcon";
import EmptyTaxIcon from "@/components/UI/svgs/EmptyTaxIcon";
import EmptyRouteIcon from "@/components/UI/svgs/EmptyRouteIcon";
import EmptyFleetsIcon from "@/components/UI/svgs/EmptyFleetsIcon";
import EmptyTrackingIcon from "@/components/UI/svgs/EmptyTrackingIcon";
import EmptyCardIcon from "@/components/UI/svgs/EmptyCardIcon";
import QRCode from "@/components/UI/svgs/QRCode";
import EmptyBookingIcon from "@/components/UI/svgs/EmptyBookingIcon";
import EmptyDispatchIcon from "@/components/UI/svgs/EmptyDispatchIcon";
import ArrowDownFilled from "@/components/UI/svgs/ArrowDownFilled";
import SortIcon from "@/components/UI/svgs/SortIcon";
import SearchDropDownIcon from "@/components/UI/svgs/SearchDropDownIcon";
import AcknowledgedIcon from "@/components/UI/svgs/AcknowledgedIcon";

Vue.component("empty-state", EmptyState);
Vue.component('star-rate', StarWrapper)

Vue.component("show-password-icon", ShowPasswordIcon);
Vue.component("hide-password-icon", HidePasswordIcon);
Vue.component("button-loader", ButtonLoader);
Vue.component("page-header", PageHeader);
Vue.component("loader", Loader);
Vue.component("modal", Modal);
Vue.component("form-select", FormSelect);
Vue.component("vertical-ellipsis", VerticalEllipsis);
Vue.component("search-icon", SearchIcon);
Vue.component("delete-modal", DeleteModal);
Vue.component("update-status-modal", UpdateStatusModal);
Vue.component("image-upload", ImageUpload);
Vue.component("document-upload", DocumentUpload);
Vue.component("tool-tip", Tooltip);
Vue.component("primary-button", PrimaryButton);
Vue.component("email-input", EmailInput);
Vue.component("radio-input", RadioInput);
Vue.component("base-checkbox", BaseCheckbox);
Vue.component("bulk-action", BulkAction);
Vue.component("base-button", BaseButton);
Vue.component("base-input", BaseInput);
Vue.component("badge", Badge);
Vue.component("accordion", Accordion);
Vue.component("accordion-item", AccordionItem);
Vue.component('auto-complete', AutoComplete)

Vue.component("fulfillment-icon", FulfillmentIcon);
Vue.component("accept-package-icon", AcceptPackageIcon);
Vue.component("accept-icon", AcceptIcon);
Vue.component("cancel-icon", CancelIcon);
Vue.component("card-icon", CardIcon);
Vue.component("decline-icon", DeclineIcon);
Vue.component("details-icon", DetailsIcon);
Vue.component("vehicle-icon", VehicleIcon);
Vue.component("eye-icon", EyeIcon);
Vue.component("edit-icon", EditIcon);
Vue.component("timeline-icon", TimelineIcon);
Vue.component("package-icon", PackageAndTagIcon);
Vue.component("label-icon", LabelIcon);
Vue.component("message-icon", MessageIcon);
Vue.component("process-icon", ProcessIcon);
Vue.component("return-icon", ReturnIcon);
Vue.component("table-icon", TableIcon);
Vue.component("tracking-icon", TrackingIcon);
Vue.component("update-icon", UpdateIcon);
Vue.component("upload-doc-icon", UploadDocIcon);
Vue.component("remove-icon", RemoveIcon);
Vue.component("empty-table-icon", EmptyTableIcon);
Vue.component("action-popup", ActionPopup);
Vue.component("empty-users-icon", EmptyUsersIcon);
Vue.component("empty-roles-icon", EmptyRolesIcon);
Vue.component("empty-kpi-icon", EmptyKPIIcon);
Vue.component("empty-function-icon", EmptyFunctionIcon);
Vue.component("empty-job-level-icon", EmptyJobLevelIcon);
Vue.component("empty-designation-icon", EmptyDesignationIcon);
Vue.component("empty-incident-icon", EmptyIncidentIcon);
Vue.component("empty-transload-icon", EmptyTransloadIcon);
Vue.component("empty-location-icon", EmptyLocationIcon);
Vue.component("empty-tax-icon", EmptyTaxIcon);
Vue.component("empty-route-icon", EmptyRouteIcon);
Vue.component("empty-fleets-icon", EmptyFleetsIcon);
Vue.component("empty-card-icon", EmptyCardIcon);
Vue.component("empty-booking-icon", EmptyBookingIcon);
Vue.component("empty-tracking-icon", EmptyTrackingIcon);
Vue.component("qrcode", QRCode);
Vue.component("arrow-down-filled", ArrowDownFilled);
Vue.component("sort-icon", SortIcon);
Vue.component("search-drop-down-icon", SearchDropDownIcon);
Vue.component("acknowledged-icon", AcknowledgedIcon);
Vue.component("empty-dispatch-icon", EmptyDispatchIcon);